import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import assets from 'modules/assets'
import Slider from 'react-slick'

class Carousel extends Component {
  render() {
    var settings = {
      slidesToShow: 3,
      accessibility: true,
      arrows: true,
      lazyLoad: true,
      mobileFirst: true,
      afterChange: this.afterChange
    }

    let numOfImages = [...Array(this.props.end - this.props.start + 1).fill('placeholder')]
    return (
      <section className="center carousel">
        <Slider {...settings}>
          {
            numOfImages.map((el, i) => {
              return <div key={i}><img className="orange"src={assets('images/carousel/' + (i + this.props.start) + '.jpg')}></img></div>
            })
          }
        </Slider>
      </section>
    )
  }
}
Carousel.contextTypes = {
}
Carousel.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
  }
}

export default connect(mapStateToProps)(Carousel)



// WEBPACK FOOTER //
// ./src/components/Utils/Carousel.js